<script>
    export default{
        name: "DotWrapper",
        render : function(createElement){
            let size = this.size;
            let grid = this.grid;

            return createElement('div',
                {
                    attrs: {
                        id: 'backgroundCanvas',
                        ref: 'backgroundCanvas'
                    }
                },
                Array.apply(null, {length:this.count}).map(function(val, index){
                    let line = {width: size + "em", height: size + "em"};

                    let classes = 'dot';

                    if(index%grid[0] === grid[0]-1 && index>0){
                        classes += ' breakline';
                    }

                    classes += (index%grid[0] < grid[0]/2) ? ' leftSide' : ' rightSide';

                    return createElement('div',
                        {
                            class: classes,
                            style: line
                        }
                    );
                })
            );
        },
        props:{
            count:{
                type: Number,
                required: true
            },
            size:{
                type: Number,
                required: true
            },
            grid:{
                type: Array,
                required: false
            }
        }
    }
</script>